export const CLOUDINARY_IMAGE_CATEGORIES = ['landscape', 'square', 'portrait', 'logo', 'landscapeLogo'];

export const DEFAULT_RATIOS = {
    landscape: 16 / 9,
    square: 1,
    portrait: 9 / 16,
    logo: 1,
    landscapeLogo: 3,
};